import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

type BuukdLogoProps = {
  to?: string;
  className?: string;
  textClassName?: string;
};

export function BuukdLogo({ to = "/", className, textClassName }: BuukdLogoProps) {
  const content = (
    <>
      <img
        src={`${import.meta.env.BASE_URL || "/"}pwa-512x512.png`}
        alt="Buukd"
        width={32}
        height={32}
        className="h-8 w-8 rounded-[16px] object-contain shrink-0 block"
        loading="eager"
        onError={(e) => {
          const t = e.target as HTMLImageElement;
          t.style.display = "none";
        }}
      />
      <span
        className={cn(
          "text-xl font-bold bg-gradient-to-br from-pink-500 to-purple-500 bg-clip-text text-transparent animate-gradient-subtle",
          textClassName
        )}
      >
        Buukd
      </span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cn("flex items-center gap-2", className)}>
        {content}
      </Link>
    );
  }

  return <div className={cn("flex items-center gap-2", className)}>{content}</div>;
}
